"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const styles_1 = require("@mui/material/styles");
const ColumnPanel_styles_1 = __importDefault(require("./ColumnPanel.styles"));
const ColumnPanel = ({ label, links, }) => {
    const theme = (0, styles_1.useTheme)();
    return (react_1.default.createElement(Box_1.default, null,
        react_1.default.createElement(Typography_1.default, { sx: ColumnPanel_styles_1.default.column(theme) }, label),
        links.map((item) => (react_1.default.createElement(Typography_1.default, { key: item.caption, sx: ColumnPanel_styles_1.default.item },
            react_1.default.createElement(Link_1.default, { href: item.link, sx: ColumnPanel_styles_1.default.link }, item.caption))))));
};
exports.default = ColumnPanel;
